// Network status on the web (FR-040; data-model §12; research R15): `navigator.onLine` with the
// window `online`/`offline` events. Justified platform pair: NetInfo's web module listens only to
// `navigator.connection` `change` events where that API exists (Chromium), which do not fire when
// the connection drops or returns, so the banner would never clear.
import { useSyncExternalStore } from "react";

import { isOnline } from "./networkStatus";

export { isOnline };

function subscribe(onChange: () => void): () => void {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

const snapshot = () => navigator.onLine;
const serverSnapshot = () => true;

export function useNetworkStatus(): { online: boolean } {
  const connected = useSyncExternalStore(subscribe, snapshot, serverSnapshot);
  return {
    online: isOnline({ isConnected: connected, isInternetReachable: null }),
  };
}
